import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const CalculatorIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M10 22H14C19 22 21 20 21 15V9C21 4 19 2 14 2H10C5 2 3 4 3 9V15C3 20 5 22 10 22Z"
		/>

		<path
			opacity={0.4}
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M16.5 7.58V8.58C16.5 9.4 15.83 10.08 15 10.08H9C8.18 10.08 7.5 9.41 7.5 8.58V7.58C7.5 6.76 8.17 6.08 9 6.08H15C15.83 6.08 16.5 6.75 16.5 7.58Z"
		/>

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M8.136 14H8.148" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M11.995 14H12.007" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M15.854 14H15.866" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M8.136 17.5H8.148" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M11.995 17.5H12.007" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M15.854 17.5H15.866" />
	</SvgIcon>
)

export default CalculatorIconAtom
